import React from 'react'
import { Large } from '@/components/ui/typography'
import { LoadingSpinner } from '@/components/ui/spinner'
import { cn } from '@/lib/utils'

interface LoadingMessageProps {
    /**
     * The message to display while loading (e.g., "Loading products...", "Loading collections...")
     */
    message: string
    /**
     * Optional className for the container
     */
    className?: string
}

/**
 * LoadingMessage Component
 *
 * A reusable component for displaying loading states in search panels and modals.
 * Displays a centered message with a loading spinner.
 *
 * @example
 * <LoadingMessage message="Loading products..." />
 */
export const LoadingMessage: React.FC<LoadingMessageProps> = ({
    message,
    className,
}) => {
    return (
        <div
            className={cn(
                'flex w-full flex-col items-center rounded-xl bg-secondary py-12',
                className,
            )}
            role="status"
            aria-live="polite"
            aria-label={message}
        >
            <LoadingSpinner className="mb-4 size-8" />
            <Large className="text-muted-foreground">{message}</Large>
        </div>
    )
}
